import { createFileRoute } from '@tanstack/react-router';
import { CreateJobPage } from '../components/community/CreateJobPage';

export const Route = createFileRoute('/community/jobs/new')({
  component: CreateJobPage,
});
